import * as React from 'react';
import { IFilter, FilterType, IFilterDataDate, IFilterDataDropdown, IFilterDataRadio, IFilterDataTags, IFilterDataTermCheck } from '../../interfaces/IFilter';
import { IMultiSelectDropDownOption } from './../multiSelectDropDown/MultiSelectDropDown'
import { INode } from '../../interfaces/INode';

export interface IFilterProps {
    filters: IFilter[];
    title?: string;
    applyFilter: (filter: any, filterObjects: any) => void;
    dismiss: () => void;
    highlightColor: string;
}

export interface IFilterState {
    filters: IFilter[];

    checkboxFilterMap: { [key: string]: boolean };

    selectedPeopleMap: { [key: string]: any[] };

    nodesMap: { [key: string]: INode[] };
    selectedNodesMap: { [key: string]: INode[] };

    dropdownValueMap: { [key: string]: DropdownObject };

    radioMap: { [key: string]: RadioObject };
    typeDateMap: { [key: string]: DateObject };
    multiSelectFieldsMap: { [key: string]: IMultiSelectDropDownOption[] };
}

export interface RadioObject {
    radioValue: string;
    defaultValue: string;
    options: { key: string, text: string }[];
}

export interface DateObject {
    startDate: Date;
    endDate: Date;
    typeDate: string;
}

export interface DropdownObject {
    options: { key: string, displayName: string, disabled?: boolean }[];
    selectedValue: string;
}

// const DayPickerStrings: IDatePickerStrings = {
//     months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
//     shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
//     days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
//     shortDays: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
//     goToToday: 'Go to today',
//     prevMonthAriaLabel: 'Go to previous month',
//     nextMonthAriaLabel: 'Go to next month',
//     prevYearAriaLabel: 'Go to previous year',
//     nextYearAriaLabel: 'Go to next year'
// };

export class Filter extends React.Component<IFilterProps, IFilterState> {

    constructor(props: IFilterProps, state: IFilterState) {
        super(props, state);

        let propFilters = this.props.filters;

        propFilters = propFilters.sort((f1, f2) => {
            if (!f1.order) {
                return -1;
            } else if (!f2.order) {
                return -1;
            }
            else if (f1.order > f2.order) {
                return 1;
            }
            return -1;
        });

        let nodesMap: { [key: string]: INode[] } = {};
        let radioMap: { [key: string]: RadioObject } = {};
        let typeDateMap: { [key: string]: DateObject } = {};
        let multiSelectFieldsMap: { [key: string]: IMultiSelectDropDownOption[] } = {};
        let dropdownValueMap: { [key: string]: DropdownObject } = {};

        propFilters.forEach((filter) => {
            switch (filter.type) {
                case FilterType.Date: {
                    let data =  filter.data as IFilterDataDate;
                    let filterObject: DateObject = {
                        endDate: data.selected?data.selected.startDate:null,
                        startDate: data.selected?data.selected.endDate:null,
                        typeDate: data.selected?"Periode":"All"
                    };
                    typeDateMap[filter.title] = filterObject;

                    break;
                }
                case FilterType.Dropdown: {
                    let data =  filter.data as IFilterDataDropdown;
                    let options: { key: string, displayName: string, disabled: boolean }[] = [];
                    options.push({
                        key: "",
                        displayName: "",
                        disabled: false
                    });
                    options.push(...data.options.map((option) => {
                        return {
                            key: option.key,
                            displayName: option.value,
                            disabled: option.disabled
                        };
                    }));
                    let filterObject: DropdownObject = {
                        options: options,
                        selectedValue: data.selected?data.selected:""
                    };
                    dropdownValueMap[filter.title] = filterObject;
                    break;
                }
                case FilterType.Radio: {
                    let data =  filter.data as IFilterDataRadio;
                    let options = data.options.map((object) => {
                        return {
                            key: object.key,
                            text: object.value
                        };
                    });
                    let filterObject: RadioObject = {
                        defaultValue: data.default,
                        options: options,
                        radioValue: data.selected?data.selected:data.default
                    };
                    radioMap[filter.title] = filterObject;
                    break;
                }
                case FilterType.Tags: {
                    let data = filter.data as IFilterDataTags;
                    let tagOptions = data.options.map((option) => {
                        return {
                            key: option.key,
                            text: option.text,
                            selected: option.selected,
                            label: null,
                            id: null
                        };
                    });
                    multiSelectFieldsMap[filter.title] = tagOptions;
                    break;
                }
                case FilterType.TermCheckbox: {
                    let data = filter.data as IFilterDataTermCheck;
                    let nodes: INode[] = data.options;
                    nodesMap[filter.title] = nodes;
                    break;
                }
                case FilterType.People: {
                    break;
                }
            }
        });

        this.state = {
            selectedNodesMap: {},
            checkboxFilterMap: {},
            selectedPeopleMap: {},

            filters: propFilters,
            dropdownValueMap,
            multiSelectFieldsMap,
            nodesMap,
            radioMap,
            typeDateMap,
        };

        //this.getFilterMultiple = this.getFilterMultiple.bind(this);
    }

    // private clearFilters = () => {
    //     let propFilters = this.props.filters;

    //     let nodesMap: { [key: string]: INode[] } = {};
    //     let radioMap: { [key: string]: RadioObject } = {};
    //     let typeDateMap: { [key: string]: DateObject } = {};
    //     let multiSelectFieldsMap: { [key: string]: IMultiSelectDropDownOption[] } = {};
    //     let dropdownValueMap: { [key: string]: DropdownObject } = {};

    //     propFilters.forEach((filter) => {
    //         switch (filter.type) {
    //             case FilterType.Date: {
    //                 let data = filter.data as IFilterDataDate;
    //                 data.selected = undefined;
    //                 let filterObject: DateObject = {
    //                     endDate: null,
    //                     startDate: null,
    //                     typeDate: "All"
    //                 };
    //                 typeDateMap[filter.title] = filterObject;

    //                 break;
    //             }
    //             case FilterType.Dropdown: {
    //                 let data = filter.data as IFilterDataDropdown;
    //                 data.selected = undefined;
    //                 let options: { key: string, displayName: string, disabled: boolean }[] = [];
    //                 options.push({
    //                     key: "",
    //                     displayName: "",
    //                     disabled: false
    //                 });
    //                 options.push(...data.options.map((option, index) => {
    //                     return {
    //                         key: option.key,
    //                         displayName: option.value,
    //                         disabled: option.disabled
    //                     };
    //                 }));
    //                 let filterObject: DropdownObject = {
    //                     options: options,
    //                     selectedValue: ""
    //                 };
    //                 dropdownValueMap[filter.title] = filterObject;
    //                 break;
    //             }
    //             case FilterType.Radio: {
    //                 let data = filter.data as IFilterDataRadio;
    //                 data.selected = undefined;
    //                 let options = data.options.map((object, index) => {
    //                     return {
    //                         key: object.key,
    //                         text: object.value
    //                     };
    //                 });
    //                 let filterObject: RadioObject = {
    //                     defaultValue: data.default,
    //                     options: options,
    //                     radioValue: data.default
    //                 };
    //                 radioMap[filter.title] = filterObject;
    //                 break;
    //             }
    //             case FilterType.Tags: {
    //                 let data = filter.data as IFilterDataTags;
    //                 let tagOptions = data.options.map((option, index) => {
    //                     return {
    //                         key: option.key,
    //                         text: option.text,
    //                         selected: false,
    //                         label: null,
    //                         id: null
    //                     };
    //                 });
    //                 multiSelectFieldsMap[filter.title] = tagOptions;
    //                 break;
    //             }
    //             case FilterType.TermCheckbox: {
    //                 let data = filter.data as IFilterDataTermCheck;
    //                 let nodes: INode[] = data.options;
    //                 nodesMap[filter.title] = this.clearNodes(nodes);
    //                 break;
    //             }
    //             case FilterType.People: {
    //                 let data = filter.data as IFilterDataPeople;
    //                 data.selected = [];
    //                 break;
    //             }
    //         }
    //     });

    //     this.setState({
    //         selectedNodesMap: {},
    //         checkboxFilterMap: {},
    //         selectedPeopleMap: {},

    //         filters: propFilters,
    //         dropdownValueMap,
    //         multiSelectFieldsMap,
    //         nodesMap,
    //         radioMap,
    //         typeDateMap,
    //     }, this.getFilterMultiple);
    // }

    // private getFilterMultiple() {
    //     let filters = [];

    //     let propFilters = this.state.filters;

    //     propFilters.forEach((filter) => {
    //         switch (filter.type) {
    //             case FilterType.Radio: {
    //                 let data = filter.data as IFilterDataRadio;
    //                 let filterObject = this.state.radioMap[filter.title];
    //                 if (filterObject.radioValue !== filterObject.defaultValue) {
    //                     filters.push({
    //                         fields: [{
    //                             field: data.field,
    //                             type: filter.data.type,
    //                             value: filterObject.radioValue,
    //                             condition: 'Or',
    //                             operator: 'Equal'
    //                         }],
    //                         condition: "And"
    //                     });
    //                 }
    //                 break;
    //             }
    //             case FilterType.Dropdown: {
    //                 let data = filter.data as IFilterDataDropdown;
    //                 let filterObject = this.state.dropdownValueMap[filter.title];
    //                 if (filterObject) {
    //                     filters.push({
    //                         fields: [{
    //                             field: data.field,
    //                             type: filter.data.type,
    //                             value: filterObject,
    //                             condition: 'Or',
    //                             operator: 'Equal'
    //                         }],
    //                         condition: "And"

    //                     });

    //                 }
    //                 break;
    //             }
    //             case FilterType.Date: {
    //                 let filterObject = this.state.typeDateMap[filter.title];

    //                 if (filterObject.typeDate !== "All") {
    //                     if (filterObject.endDate) {
    //                         filters.push({
    //                             fields: [
    //                                 {
    //                                     field: "IAMessageEndTime",
    //                                     type: "DateTime",
    //                                     value: filterObject.endDate.toISOString(),
    //                                     condition: "Or",
    //                                     operator: "LessThanOrEqual"
    //                                 },
    //                                 {
    //                                     field: "IAMessageEndTime",
    //                                     type: "DateTime",
    //                                     value: "",
    //                                     condition: "Or",
    //                                     operator: "IsNull"
    //                                 }
    //                             ],
    //                             condition: "And"
    //                         });
    //                     }
    //                     if (filterObject.startDate) {
    //                         filters.push({
    //                             fields: [
    //                                 {
    //                                     field: "IAMessageStartTime",
    //                                     type: "DateTime",
    //                                     value: filterObject.startDate.toISOString(),
    //                                     condition: "And",
    //                                     operator: "GreaterThanOrEqual"
    //                                 }
    //                             ],
    //                             condition: "And"
    //                         });
    //                     }
    //                 }
    //                 break;
    //             }
    //             case FilterType.People: {
    //                 let filterObject = this.state.selectedPeopleMap[filter.title];
    //                 let data = filter.data as IFilterDataPeople;

    //                 if (filterObject && filterObject.length > 0) {
    //                     let list = [];
    //                     filterObject.forEach(term => {
    //                         list.push({
    //                             field: data.field,
    //                             type: filter.data.type,
    //                             value: term.title,
    //                             condition: 'Or',
    //                             operator: 'Includes'
    //                         });
    //                     });
    //                     if (list && list.length > 0) {
    //                         filters.push({
    //                             fields: [...list],
    //                             condition: "And"
    //                         });

    //                     }
    //                 }
    //                 break;
    //             }
    //             case FilterType.Tags: {
    //                 let filterObject = this.state.multiSelectFieldsMap[filter.title];
    //                 let data = filter.data as IFilterDataTags;

    //                 if (filterObject && filterObject.length > 0) {
    //                     let list = [];
    //                     filterObject.forEach(term => {
    //                         list.push({
    //                             field: data.field,
    //                             type: filter.data.type,
    //                             value: term,
    //                             condition: 'Or',
    //                             operator: 'Contains'
    //                         });
    //                     });
    //                     if (list && list.length > 0) {
    //                         filters.push({
    //                             fields: [...list],
    //                             condition: "And"
    //                         });

    //                     }
    //                 }
    //                 break;
    //             }
    //             case FilterType.TermCheckbox: {
    //                 let filterObject = this.state.nodesMap[filter.title];
    //                 let data = filter.data as IFilterDataTermCheck;

    //                 if (filterObject && filterObject.length > 0) {
    //                     let list = [];
    //                     let nodesList = this.getNodes(filterObject, []);
    //                     nodesList.forEach(term => {
    //                         list.push({
    //                             field: data.field,
    //                             type: filter.data.type,
    //                             value: term,
    //                             condition: 'Or',
    //                             operator: 'Contains'
    //                         });
    //                     });
    //                     if (list && list.length > 0) {
    //                         filters.push({
    //                             fields: [...list],
    //                             condition: "And"
    //                         });
    //                     }
    //                 }
    //                 break;
    //             }
    //         }
    //     });
    //     this.props.applyFilter(propFilters, filters);
    // }

    // public render(): React.ReactElement<IFilterProps> {
    //     let filters = [];
    //     let propFilters = this.state.filters;

    //     propFilters.forEach((filter) => {
    //         let element: JSX.Element;
    //         switch (filter.type) {
    //             case FilterType.Radio: {
    //                 element = this.radioFilter(filter);
    //                 break;
    //             }
    //             case FilterType.Dropdown: {
    //                 element = this.dropdownFilter(filter);
    //                 break;
    //             }
    //             case FilterType.Date: {
    //                 element = this.dateFilter(filter);
    //                 break;
    //             }
    //             case FilterType.People: {
    //                 element = this.peopleFilter(filter);
    //                 break;
    //             }
    //             case FilterType.Tags: {
    //                 element = this.multiSelectFilter(filter);
    //                 break;
    //             }
    //             case FilterType.TermCheckbox: {
    //                 element = this.termCheckboxFilter(filter);
    //                 break;
    //             }
    //         }
    //         let filterElement = this.addFilterLabel(element, filter.title);
    //         filters.push(filterElement);
    //     });

    //     let panel = (
    //         <Panel
    //             isOpen={true}
    //             type={PanelType.smallFixedFar}
    //             onDismiss={() => this.props.dismiss()}
    //             headerText={this.props.title}
    //             closeButtonAriaLabel="Close"
    //             isFooterAtBottom={true}
    //         >
    //             <div style={{
    //                 color: "red",
    //                 position: "absolute",
    //                 top: "34px",
    //                 right: "26px"
    //             }}>
    //                 <IconButton
    //                     iconProps={{ iconName: 'ClearFilter' }}
    //                     title="Clear filters"
    //                     ariaLabel="Clear filters"
    //                     style={{ color: "red" }}
    //                     onClick={() => {
    //                         this.clearFilters();
    //                     }}
    //                 />
    //             </div>
    //             <div>
    //                 {filters}
    //             </div>
    //         </Panel>
    //     );

    //     return (panel);
    // }

    // private clearNodes(nodes: INode[]) {
    //     nodes.forEach(node => {
    //         node.checked = false;
    //         node.markedChild = false;
    //         if (node.childNodes) {
    //             this.clearNodes(node.childNodes);
    //         }
    //     });
    //     return nodes;
    // }

    // private addFilterLabel(filterElement: JSX.Element, title: string, icon?: string, ) {
    //     let element = (
    //         <div style={{ marginTop: "30px", clear: "both" }}>
    //             <div className={styles.filterLabel}>
    //                 {icon && <Icon iconName={icon} />}
    //                 <Label style={{ float: "left" }}>{title}</Label>
    //             </div>
    //             <div>
    //                 {filterElement}
    //             </div>
    //         </div>
    //     );
    //     return element;
    // }

    // private checkboxFilter(data: any, title: string) {
    //     let element = (
    //         <div>
    //             <Checkbox label={data.value} onChange={
    //                 () => {
    //                     let filterObject = this.state.checkboxFilterMap[title];
    //                     if (!filterObject) {
    //                         filterObject = true;
    //                     } else {
    //                         filterObject = !filterObject;
    //                     }
    //                     this.setState({ checkboxFilterMap: this.state.checkboxFilterMap });
    //                 }
    //             } />
    //         </div>
    //     );
    //     return element;
    // }


    // private radioFilter(filter: IFilter) {
    //     let data = filter.data as IFilterDataRadio;

    //     let options = data.options.map((object, index) => {
    //         return {
    //             key: object.key,
    //             text: object.value
    //         };
    //     });
    //     let element = (
    //         <ChoiceGroup
    //             className="radio"
    //             selectedKey={this.state.radioMap[filter.title].radioValue}
    //             options={options}
    //             onChange={(event, option) => {
    //                 let filterObject = this.state.radioMap[filter.title];
    //                 filterObject.radioValue = option.key;
    //                 data.selected = option.key;
    //                 this.setState({ radioMap: this.state.radioMap }, () =>
    //                     this.getFilterMultiple());
    //             }}
    //             required={true}
    //         />);
    //     return element;
    // }

    // private dropdownFilter(filter: IFilter) {
    //     let filterObject = this.state.dropdownValueMap[filter.title];
    //     let data = filter.data as IFilterDataDropdown;
    //     let element = (<IADropDown
    //         label={''}
    //         selectedOption={filterObject.selectedValue}
    //         options={filterObject.options}
    //         onChange={(selectedOption) => {
    //             filterObject.selectedValue = selectedOption;
    //             data.selected = selectedOption;
    //             // this.state.dropdownValueMap[filter.title] = filterObject;
    //             this.setState({ dropdownValueMap: this.state.dropdownValueMap }, () =>
    //                 this.getFilterMultiple());
    //         }}
    //     />);
    //     return element;
    // }

    // private dateFilter(filter: IFilter) {
    //     let filterObject = this.state.typeDateMap[filter.title];
    //     let data = filter.data as IFilterDataDate;
    //     let element = (
    //         <div style={{ marginTop: "30px" }}>
    //             <ChoiceGroup
    //                 selectedKey={filterObject.typeDate}
    //                 options={[
    //                     {
    //                         key: 'All',
    //                         text: 'All time'
    //                     },
    //                     {
    //                         key: 'Periode',
    //                         text: 'Period:'
    //                     },
    //                 ]}
    //                 onChange={(ev: any, option: IChoiceGroupOption) => {
    //                     filterObject.typeDate = option.key;

    //                     this.setState({ typeDateMap: this.state.typeDateMap });
    //                 }}
    //             />
    //             <div style={{ marginTop: "10px" }}>
    //                 <DatePicker
    //                     disabled={filterObject.typeDate === "All" ? true : false}
    //                     strings={DayPickerStrings}
    //                     placeholder="Start date"
    //                     ariaLabel="Select a start date"
    //                     maxDate={filterObject.endDate}
    //                     onSelectDate={(startDate: Date) => {
    //                         filterObject.startDate = startDate;
    //                         if (!data.selected) {
    //                             data.selected = { startDate: null, endDate: null};
    //                         }
    //                         data.selected.startDate = startDate;
    //                         this.setState({ typeDateMap: this.state.typeDateMap }, () =>
    //                             this.getFilterMultiple());
    //                     }}
    //                     value={filterObject.startDate}
    //                 />
    //             </div>
    //             <div style={{ marginTop: "10px" }}>
    //                 <DatePicker
    //                     disabled={filterObject.typeDate === "All" ? true : false}
    //                     strings={DayPickerStrings}
    //                     placeholder="End date"
    //                     ariaLabel="Select an end date"
    //                     minDate={filterObject.startDate}
    //                     onSelectDate={(endDate: Date) => {
    //                         filterObject.endDate = endDate;
    //                         if (!data.selected) {
    //                             data.selected = { startDate: null, endDate: null};
    //                         }
    //                         data.selected.endDate = endDate;
    //                         this.setState({ typeDateMap: this.state.typeDateMap }, () =>
    //                             this.getFilterMultiple());
    //                     }}
    //                     value={filterObject.endDate}
    //                 />
    //             </div>
    //         </div>
    //     );

    //     return element;
    // }

    // private peopleFilter(filter: IFilter) {
    //     let data = filter.data as IFilterDataPeople;

    //     let filterObject = this.state.selectedPeopleMap[filter.title];
    //     if (!filterObject) {
    //         this.state.selectedPeopleMap[filter.title] = [];
    //     }
    //     if (data.selected) {
    //         filterObject = data.selected;
    //     }
    //     let element = (
    //         <div style={{ marginTop: '10px' }}>
    //             {/* <PeoplePicker
    //                 peopleList={data.options}
    //                 selectedValues={filterObject}
    //                 updateContacList={(items: any[]) => {
    //                     filterObject = items;
    //                     this.state.selectedPeopleMap[filter.title] = filterObject;
    //                     data.selected = filterObject;
    //                     this.setState({ selectedPeopleMap: this.state.selectedPeopleMap }, () =>
    //                         this.getFilterMultiple());
    //                 }}
    //             /> */}
    //         </div>
    //     );
    //     return element;
    // }


    // private multiSelectFilter(filter: IFilter) {
    //     let filterObject = this.state.multiSelectFieldsMap[filter.title];
    //     let data = filter.data as IFilterDataTags;

    //     let element = (
    //         <IAMultiSelectDropDown
    //             options={filterObject}
    //             styles={data.styles}
    //             themeColor={data.themeColor}
    //             onSelectOptions={(option) => {
    //                 let list = filterObject;
    //                 if (!list) {
    //                     list = [];
    //                 }
    //                 list.push(option);
    //                 this.setState({ multiSelectFieldsMap: this.state.multiSelectFieldsMap }, () =>
    //                     this.getFilterMultiple());
    //             }}
    //         />
    //     );

    //     return element;
    // }

    // private termCheckboxFilter(filter: IFilter) {
    //     let filterObject = this.state.nodesMap[filter.title];
    //     let data = filter.data as IFilterDataTermCheck;

    //     let element = (
    //         <IATermCheckbox
    //             label={''}
    //             nodes={filterObject}
    //             selectedValues={this.state.selectedNodesMap[filter.title]}
    //             nodeComparison={data.comparison}
    //             onChange={(nodes, selectedValues) => {
    //                 let mapObject = this.state.nodesMap[filter.title];
    //                 mapObject = nodes;
    //                 this.setState({ nodesMap: this.state.nodesMap }, () => {
    //                     this.getFilterMultiple();
    //                 });
    //             }}
    //             highlightColor={this.props.highlightColor}
    //         />

    //     );

    //     return element;
    // }

    // private onChangeCategories = (nodes, selectedValues, filter) => {
    //     let list = IATermCheckbox.getSelectedValues(nodes, selectedValues, "id");
    //     let mapObject = this.state.nodesMap[filter.title];
    //     mapObject = nodes;
    //     this.state.selectedNodesMap[filter.title] = list;
    //     this.setState({ nodesMap: this.state.nodesMap, selectedNodesMap: this.state.selectedNodesMap }, () => {
    //         this.getFilterMultiple();
    //     });
    // }

    // private getNodes = (nodes, list) => {

    //     nodes.forEach(node => {
    //         if (node.checked) {
    //             list.push(node.defaultLabel);
    //             if (node.childNodes && node.childNodes.length > 0) {
    //                 this.getNodes(node.childNodes, list);
    //             }
    //         }
    //     });
    //     return list;
    // }
}
